import { dashboardAscResolver, agencesAscResolver } from './pages/dashboard/dashboard-asc.resolver';
import { dashboardAgenceAscResolver } from './pages/dashboard-agence/dashboard-agence-asc.resolver';
import {
  banquesAscResolver,
  naturesAscResolver,
  chequeEditAscResolver,
} from './pages/create/create-asc.resolver';
import { pendingAscResolver } from './pages/pending/pending-asc.resolver';
import { detailAscResolver } from './pages/detail/detail-asc.resolver';
import { listDemandesAscResolver, listAgencesAscResolver } from './pages/list/list-asc.resolver';
import { tireursAscResolver } from './pages/tireurs/tireurs-asc.resolver';
import { chequesAttenteAscResolver } from './pages/cheques-attente/cheques-attente-asc.resolver';
import { chequeDetailResolver } from './pages/cheque-detail/cheque-detail.resolver';
import { Route } from '@angular/router';
import { roleGuard } from '@/core/guards/role.guard';
import {
  ASC_SIEGE_ROLES,
  ASC_AGENCE_ROLES,
  ASC_CREATE_ROLES,
  ASC_PENDING_ROLES,
  ASC_CHEQUES_ROLES,
  ASC_LIST_ROLES,
  ASC_ALL,
} from '@/core/constants/access-roles';

export const ascRoutes: Route = {
  path: 'asc',
  children: [
    {
      path: 'dashboard',
      canActivate: [roleGuard([...ASC_SIEGE_ROLES])],
      resolve: { dashboard: dashboardAscResolver, agences: agencesAscResolver },
      loadComponent: () =>
        import('./pages/dashboard/dashboard-asc.component').then((m) => m.DashboardAscComponent),
    },
    {
      path: 'dashboard/agence',
      canActivate: [roleGuard([...ASC_AGENCE_ROLES])],
      resolve: { dashboard: dashboardAgenceAscResolver },
      loadComponent: () =>
        import('./pages/dashboard-agence/dashboard-agence-asc.component').then(
          (m) => m.DashboardAgenceAscComponent,
        ),
    },
    {
      path: 'client-search',
      canActivate: [roleGuard([...ASC_CREATE_ROLES])],
      loadComponent: () =>
        import('./pages/client-search/client-search.component').then((m) => m.ClientSearchComponent),
    },
    {
      path: 'create',
      canActivate: [roleGuard([...ASC_CREATE_ROLES])],
      resolve: {
        banques: banquesAscResolver,
        natures: naturesAscResolver,
        chequeToEdit: chequeEditAscResolver,
      },
      loadComponent: () =>
        import('./pages/create/create.component').then((m) => m.CreateAscComponent),
    },
    {
      path: 'pending',
      canActivate: [roleGuard([...ASC_PENDING_ROLES])],
      resolve: { demandes: pendingAscResolver },
      loadComponent: () =>
        import('./pages/pending/pending.component').then((m) => m.PendingComponent),
    },
    {
      path: 'detail/:id',
      canActivate: [roleGuard([...ASC_ALL])],
      resolve: { demande: detailAscResolver },
      loadComponent: () =>
        import('./pages/detail/detail.component').then((m) => m.DetailComponent),
    },
    {
      path: 'list',
      canActivate: [roleGuard([...ASC_LIST_ROLES])],
      resolve: { demandes: listDemandesAscResolver, agences: listAgencesAscResolver },
      loadComponent: () =>
        import('./pages/list/list.component').then((m) => m.ListComponent),
    },
    {
      path: 'tireurs',
      canActivate: [roleGuard([...ASC_LIST_ROLES])],
      resolve: { tireurs: tireursAscResolver },
      loadComponent: () =>
        import('./pages/tireurs/tireurs.component').then((m) => m.TireursComponent),
    },
    {
      path: 'cheque/:numcheque',
      canActivate: [roleGuard([...ASC_ALL])],
      resolve: { chequeDetail: chequeDetailResolver },
      loadComponent: () =>
        import('./pages/cheque-detail/cheque-detail.component').then((m) => m.ChequeDetailComponent),
    },
    {
      path: 'cheques-attente',
      canActivate: [roleGuard([...ASC_CHEQUES_ROLES])],
      resolve: { cheques: chequesAttenteAscResolver },
      loadComponent: () =>
        import('./pages/cheques-attente/cheques-attente.component').then(
          (m) => m.ChequesAttenteComponent,
        ),
    },
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'dashboard',
    },
  ],
};
